<template>
	<div class="store-initialization-container">
		<BaseLoader type="store-loader" />
	</div>
</template>

<script>
	import { mapGetters, mapMutations, mapActions } from 'vuex';
	import localStorageAdapter from '@/utils/LocalStorageAdapter';
	import locationService from '@/services/location.service';
	import allService from '@/services/all.service';
	import storeLoaderMixin from '@Mixin/storeLoaderMixin';
	import menuItemMixin from '@Mixin/menuItemMixin';
	import headerMixin from '@Mixin/headerMixin';
	import { getParam } from "@/utils/helper.functions";
	import { APP_STORE, MENU_ITEMS } from '@/stores/defs';

	export default {
		computed: {
			...mapGetters({
				getItem: MENU_ITEMS.GET_ITEM,
			})
		},
		mixins: [
			storeLoaderMixin,
			menuItemMixin,
			headerMixin,
		],
		props: {
			handle: {
				type: String,
				default: '',
			}
		},
		methods: {
			...mapMutations({
				resetStore: 'reset',
			}),
			...mapActions({
				setDebug: APP_STORE.SET_DEBUG,
			}),
		},
		mounted() {
			const handle = this.handle;
			const itemId = this.$attrs.itemId;
			const itemVanityName = this.$attrs.itemName;

			localStorageAdapter.removeInconsequentialItems();
			this.resetStore();

			locationService.getLocationFromHandle(handle, (response) => {
				const base = response.base;
				const forceLoad = true;
				const debug = getParam('debug');
				this.loadAll(base, forceLoad).then(() => {
					if (debug) {
						this.$modal.hide('contentModal');
						this.setDebug(true);
					}
					let route = {
						name: 'home',
						query: {
							...debug && {debug: 1}
						}
					}
					if (itemId) {
						const routeItem = {
							id: itemId,
						}
						route = this.getItemRoute(routeItem);
					} else if (itemVanityName) {
						const item = this.getItem(itemVanityName)
						if (item) {
							route = this.getItemRoute(item);
						}
					}
					this.$router.push(route);
				});
			});
		},
	}
</script>

<style lang="scss" scoped>
	@import 'commonStyle/menuCard';
	.store-initialization-container {
		width: 100vw;
		height: 100vh;
		background-color: $menu_background;
	}
</style>


// WEBPACK FOOTER //
// src/components/store-locator/StoreDeepLink.vue